import { TargitDashboardItem, TargitDashboardItemProps } from './TargitDashboardItem';
import { Dropdown, Button } from 'ui/components';
import { ReactComponent as IconFull } from 'ui/icons/icon_fullscreen.svg';
import styles from './TargitDashboard.module.scss';
import classNames from 'classnames';
import { useState } from 'react';

export interface TargitDashboardProps {
    targitItems: TargitDashboardItemProps[];
}

export const TargitDashboard: React.FC<TargitDashboardProps> = ({ targitItems }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isWorking, setIsWorking] = useState(true);
    const [isReady, setIsReady] = useState(false);
    const [fullScreen, setFullScreen] = useState(false);

    if (!targitItems || targitItems.length === 0) {
        return null;
    }
    const dashboardTitles = targitItems.map(item => item.dashboardTitle);

    const handleItemSelect = (index: number) => {
        setCurrentIndex(index);
        setIsWorking(true);
        setIsReady(false);
    };


	return (
		<div className={styles.containerDiv}>
			<div className={styles.controlsRow}> { }
				{targitItems.length > 1 &&
					<Dropdown
						items={dashboardTitles}
						selectedIndex={currentIndex}
						onSelect={handleItemSelect}
						disabled={isWorking}
						className={styles.dropdownContainer}
					/>
				}
				{isReady && !fullScreen &&
					<Button
						title='Fullscreen button'
						ariaLabel='Targit fullscreen button'
						className={styles.fullscreen_buttons}
						style="primary"
						onClick={() => setFullScreen(true)}
					>
						<IconFull aria-hidden="true" />
					</Button>
				}
			</div>
			<div className={classNames(styles.TargitDesktop)}>
				<TargitDashboardItem {...targitItems[currentIndex]}
					key={currentIndex}
					isFullScreen={fullScreen}
					onReady={() => {
						setIsWorking(false);
						setIsReady(true);
					}}
					onFullScreen={(fs) => setFullScreen(fs)} />
			</div>
		</div>
	);
}